import React, { useEffect, useState } from "react";
import { Box, Button, InputAdornment } from "@mui/material";
// import SearchIcon from "@material-ui/icons/Search";
import SearchIcon from "@mui/icons-material/Search";
import add from "../../images/add.svg";
import { Grid, TextField, Typography, styled } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fastCashDetails } from "./detailsSlice";
import moment from "moment";
import ClipLoader from "react-spinners/ClipLoader";

const GridBox = styled(Grid)({
  padding: "0px 20px",
  marginTop: "20px",
  marginBottom: "20px",
  backgroundColor: "#4EAF50",
  height: "80px",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  color: "white",
});
const RowBox = styled(Grid)({
  height: "60px",
  left: "324px",
  top: "145px",
  borderRadius: "4px",
  background: "#FFFFFF",
  boxShadow: "0px 0px 60px rgba(0, 0, 0, 0.12)",
  borderRadius: "4px",
  padding: "20px",
  display: "grid",
  marginTop: "5px",
  gridTemplateColumns: "5% 35% 20% 25% 15%",
  alignItems: "center",
});

function CashDetails(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const getDetails = useSelector((state) => state.fastCashDetail);

  const [state, setState] = useState({
    searchText: "",
    date: "",
  });

  useEffect(() => {
    dispatch(fastCashDetails({ _id: props.location.state._id, date: "" }));
  }, []);

  // const addToggle = () => {
  //   setAddModal((state) => !state);
  // };

  const handleSearch = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const searchedItems = () => {
    if (state.searchText != "") {
      const filtered = getDetails.details.filter((item) =>
        item?.amount.toString().includes(state.searchText)
      );
      return filtered;
    } else if (state.date != "") {
      let date = moment(state.date).format("DD-MM-YYYY");
      const filtered = getDetails.details.filter((item) => {
        let itemDate = moment(item.date).format("DD-MM-YYYY");
        return itemDate == date;
      });
      return filtered;
    } else {
      return getDetails.details;
    }
  };

  const goBack = () => {
    history.push("/inventory/admin/fast-cash");
  };

  return (
    <Box sx={{ mb: "20px", position: "relative" }}>
      <GridBox container>
        <Grid item lg={3} md={3} sm={3} xs={3}>
          <TextField
            fullWidth
            size="small"
            height="40px"
            label=""
            type="number"
            placeholder="Search by amount"
            sx={{
              borderRadius: "4px",
              fontSize: "12px",
              height: "40px",
              lineHeight: "14.06px",
              backgroundColor: "#f9f9f9",
              boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
              borderBottom: "1px solid #999999 !important",
            }}
            variant="outlined"
            name="searchText"
            value={state.searchText}
            onChange={handleSearch}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon className="gray-clr" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid align="center" item lg={5} md={5} sm={5} xs={5}>
          <Typography variant="h5">{props.location.state.title}</Typography>
        </Grid>

        <Grid item lg={3} md={3} sm={3} xs={3}>
          <TextField
            sx={{
              backgroundColor: "#f9f9f9",
              borderRadius: "4px",
              fontSize: "12px",
            }}
            variant="outlined"
            size="small"
            type="date"
            name="date"
            onChange={handleSearch}
            value={state.date}
          />
        </Grid>
        <Grid item lg={1} md={1} sm={1} xs={1}>
          <Button
            variant="contained"
            sx={{ backgroundColor: "white", color: "#4EAF50 !important" }}
            onClick={goBack}
          >
            Back
          </Button>
        </Grid>
        {/* <Grid item lg={1} md={1} sm={1} xs={1}>
          <Button
            variant="contained"
            className={classes.buttonAdd}
            onClick={addToggle}
          >
            Add
            <img style={{ marginLeft: "10px" }} src={add} alt="add" />
          </Button>
        </Grid> */}
      </GridBox>

      {getDetails.loading == false && (
        <>
          {getDetails.details == "" && (
            <Typography style={{ textAlign: "center" }} variant="h5">
              No Entries Found
            </Typography>
          )}
          {getDetails.details != "" && (
            <Box>
              <RowBox sx={{ background: "#4EAF8C", mt: 0 }}>
                <Typography>#</Typography>
                <Typography>Description</Typography>
                <Typography>Amount</Typography>
                <Typography>Date</Typography>
                <Typography>Balance</Typography>
              </RowBox>
              {searchedItems().map((subItem, index) => {
                return (
                  <RowBox>
                    <Typography style={{ color: "#4EAF50" }}>
                      {index + 1}
                    </Typography>
                    <Typography style={{ color: "#4EAF50" }}>
                      {subItem.detail}
                    </Typography>

                    <Typography style={{ color: "#4EAF50" }}>
                      {subItem.amount}
                    </Typography>

                    <Typography>{subItem.date}</Typography>
                    <Typography>{subItem.balance}</Typography>
                  </RowBox>
                );
              })}
            </Box>
          )}
        </>
      )}
      <Box className="centralize-loader">
        <ClipLoader size={50} color="#4DAF51" loading={getDetails.loading} />
      </Box>
    </Box>
  );
}

export default CashDetails;
